// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2YQOR","label":"styles__label___2ZfOz"};